import axiosInstance from "../axiosInstance";

export const PUTPausarAuditoriaSMA = async (idOpe, pausa, payload = null) => {
  try {
    // El cuerpo solo incluye el payload (sin "pausa")
    const body = pausa && payload ? payload : {};

    const response = await axiosInstance.put(
      `${process.env.REACT_APP_WMS_BASE_URL}/auditoria-sma/operacion/${idOpe}/pausar?pausa=${pausa}`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default PUTPausarAuditoriaSMA;
